<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto lg:mx-0  flex items-center justify-start">
        <h1 class="text-4xl font-bold lg:ml-28 ml-0 text-gray-900  aarni-font">
            Testimonials
        </h1>
    </div>
</div>
<div id="section7" class="py-16 bg-white container mx-auto font-montserrat">
    <div class="w-full flex flex-wrap pb-4 gap-y-6">
        <div
            *ngFor="let testimonial of testimonials"
            class="w-full md:w-2/4   xl:w-1/4 px-3"
        >
            <div
                class="bg-white h-full rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl ">
                <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                    <div
                        class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                    >
                        <div class="w-24 h-24 rounded-full bg-white p-1">
                            <img
                                [src]="testimonial.image"
                                [alt]="testimonial.name"
                                class="w-full h-full rounded-full object-cover"
                            />
                        </div>
                    </div>
                </div>
                <div class="pt-16 pb-8 px-6">
                    <h3
                        class="text-xl font-semibold text-center text-[#012E26] mb-2"
                    >
                        {{ testimonial.name }}
                    </h3>
                    <div class="flex justify-center mb-4">
                        <i
                            class="fa fa-star text-yellow-400"
                            *ngFor="let star of [1, 2, 3, 4, 5]"
                        ></i>
                    </div>
                    <p class="text-gray-700 text-center mb-6">
                        {{ testimonial.feedback }}
                    </p>
                    <div class="text-center text-sm text-gray-600">
                        <p class="font-semibold">{{ testimonial.course }}</p>
                        <p class="font-bold text-[#012E26]">
                            <span class="text-[#00BFA5]">
<!--                          {{ testimonial.designation }}-->
                        </span>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
